export const AUTH_INPUT = 'AUTH_INPUT' as const;
export const AUTH_OUTPUT = 'AUTH_OUTPUT' as const;
